<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <PharmacyTabLinks />

                    <PharmacyUpsertForm
                        class="mt-4"
                        :entity="entity"
                        @success="$router.push(`/pharmacies/${$route.params.id}`)"
                        @deleted="$router.push('/pharmacies')"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js'
    import PharmacyTabLinks from '@/components/pharmacies/PharmacyTabLinks'
    import PharmacyUpsertForm from '@/components/pharmacies/PharmacyUpsertForm'

    export default {
        components: {
            PharmacyTabLinks,
            PharmacyUpsertForm,
        },

        data: () => ({
            entity: undefined,
        }),

        async created() {
            await this.fetch()
        },

        methods: {
            async fetch() {
                const id = this.$route.params.id

                const [error, result] = await to(this.axios.get(`/pharmacies/${id}`))
                this.entity = result.data

                if (error) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            }
        }
    }
</script>
